export const getFontSize = (d: any) => {
    if (d._isFloatingTree || d.data.isFloating) return 14; 
    if (d.depth === 0) return 24;
    if (d.depth === 1) return 16;
    return 14;
};

export const getPadding = (d: any) => {
    if (d._isFloatingTree || d.data.isFloating) return { x: 10, y: 5 }; 
    if (d.depth === 0) return { x: 18, y: 10 }; 
    if (d.depth === 1) return { x: 12, y: 6 }; 
    return { x: 8, y: 4 }; 
};

export const shouldShowText = (d: any, effectiveScale: number) => {
    if (d.depth === 0 || d.data.isFloating) return true;
    const fs = getFontSize(d);
    return (fs * effectiveScale) > 6; 
};
